import { HttpClient } from '#client/http/index'
import {
  Point,
  PointLog,
  TotalPointParams,
  TotalPoint,
  PointOnSale,
} from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'

export const list = async ({ httpClient }: { httpClient: HttpClient }) => {
  const data: Point[] = await httpClient.get('/user/points')
  return data
}

export const listLogs = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data }: ApiResponse<PointLog[]> = await httpClient.get(
    '/user/points/logs',
  )
  return data
}

export const getTotalPoint = async (
  { httpClient }: { httpClient: HttpClient },
  params: TotalPointParams,
) => {
  const { data }: ApiResponse<TotalPoint> = await httpClient.get(
    '/user/points/total',
    {
      params,
    },
  )
  return data
}

export const getPointsOnSale = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: ApiResponse<PointOnSale[]> = await httpClient.get(
    '/user/points/onSale',
  )
  return data
}
